import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
import * as CookieService from '../CookieService';
const STKIssuesCartAction = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_PageLoad,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.STKIssuesCart_PageLoad, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const ValidateToken = (validateBO) => {
    try {
        SDISVC.callGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.ValidateToken,
            JSON.stringify(validateBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ValidateToken", response: data.response };
                        let userData = JSON.parse(data.response);
                        if (userData.LoginClickFlags_UpdatetoSession != undefined && userData.LoginClickFlags_UpdatetoSession != null) {
                            if (userData.LoginClickFlags_UpdatetoSession[0].Session_CONAME != null && userData.LoginClickFlags_UpdatetoSession[0].Session_CONAME != undefined) {
                                userData.LoginClickFlags_UpdatetoSession[0].Session_CONAME = userData.LoginClickFlags_UpdatetoSession[0].Session_CONAME.replace("–", "-");
                            }
                            let localStorageSuccess = CookieService.insertLocalStorageValues(userData.LoginClickFlags_UpdatetoSession[0]);
                        }
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

/*[08/22/22 , PC_03]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const STKIssuesCartActionUnAuth = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_PageLoad,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.STKIssuesCart_PageLoad, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const InsertAction = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_SaveStockItemCart,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "InsertAction", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const DeleteUnavailableItems = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_DeleteUnavailableItems,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "DeleteUnavailableItems", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const ItemSearchAction = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_ItemSearch,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.STKIssuesCart_ItemSearch, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const DeleteAction = (DeleteBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_DeleteAction,
            JSON.stringify(DeleteBO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "DeleteAction", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const UpdateAction = (UpdateBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_UpdateAction,
            JSON.stringify(UpdateBO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "UpdateAction", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const WorkOrderCheck = async (getFavPageBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "workordercheck", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "workorderfail", response: "fail" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const SubmitAction = (favItemBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.STKIssuesCart,
            SDIConstants.methodNames.STKIssuesCart_Submit,
            JSON.stringify(favItemBO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.STKIssuesCart_Submit, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const OrderPdf = (OrderPDFBO) => {
    try {
        ;
        SDISVC.receiveFileBase64(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_CartConfirmFile,
            JSON.stringify(OrderPDFBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "OrderPDF", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FAVITEM_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FAVITEM_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FAVITEM_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/*[08/22/22 , PC_03]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
export { STKIssuesCartAction, ItemSearchAction, WorkOrderCheck, SubmitAction, OrderPdf, insertFavPage, deleteFavPage, getCurrentFavPage, STKIssuesCartActionUnAuth, ValidateToken, InsertAction, DeleteAction, UpdateAction, DeleteUnavailableItems }